import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { PrivateRoute } from '../helpers'
import Loadable from 'react-loadable'
import { AuthService } from '../services'
import technicianTable from '../components/technician/technician-table'
import CalendarEventPage from './../pages/CalendarEvent'
import InformfixWaitConfirmPage from '../pages/informfix/InformfixWaitConfirmPage'
import InformCard from '../components/informfix/inform-card'
import InformList from '../components/informfix/inform-list'
import InformfixPendingPage from '../pages/informfix/InformfixPendingPage'
import InformfixDetailPage from '../pages/informfix/detail'
import InformfixTaskAginPage from '../pages/informfix/InformfixTaskAginPage'
import InformfixStatusOpenPage from '../pages/informfix/InformfixStatusOpenPage'
import MyJobPage from '../pages/job/MyJobPage'
import MyEventPage from '../pages/MyEventPage'

const isAuthenticated = AuthService.isLoggedIn()

const Login = Loadable({
  loader: () => import('./../components/login/Login'),
  loading: () => null,
})

const Home = Loadable({
  loader: () => import('./../pages/Home'),
  loading: () => null,
})
const Dashboard = Loadable({
  loader: () => import('./../pages/Home'),
  loading: () => null,
})

const MemberPage = Loadable({
  loader: () => import('./../pages/MemberPage'),
  loading: () => null,
})

const InformfixPage = Loadable({
  loader: () => import('./../pages/InformfixPage'),
  loading: () => null,
})

const CalendarEvent = Loadable({
  loader: () => import('./../pages/CalendarEvent'),
  loading: () => null,
})

const About = Loadable({
  loader: () => import('./../pages/About'),
  loading: () => null,
})

const ProjectPage = Loadable({
  loader: () => import('./../pages/ProjectPage'),
  loading: () => null,
})

const JobPage = Loadable({
  loader: () => import('./../pages/JobPage'),
  loading: () => null,
})

const MaintenancePage = Loadable({
  loader: () => import('./../pages/maintenance-fee'),
  loading: () => null,
})

const WeatherTodayPage = Loadable({
  loader: () => import('../components/weather-thai'),
  loading: () => null,
})

const ComplaintPage = Loadable({
  loader: () => import('../pages/complaint'),
  loading: () => null,
})

const NotificationPage = Loadable({
  loader: () => import('./../pages/notification'),
  loading: () => null,
})
const JobGroupPage = Loadable({
  loader: () => import('./../components/job-group/jobgroup-table'),
  loading: () => null,
})

////////////// ERROR PAGE ////////////////////
const NotFound = Loadable({
  loader: () => import('./../components/NotFound'),
  loading: () => null,
})
const Error401 = Loadable({
  loader: () => import('./../pages/Error401'),
  loading: () => null,
})
const Error403 = Loadable({
  loader: () => import('./../pages/Error403'),
  loading: () => null,
})

const Routers = () => {
  return (
    <div>
      <Switch>
        <PrivateRoute
          exact
          path="/"
          component={CalendarEventPage}
          isAuthenticated={isAuthenticated}
        />
        <PrivateRoute
          path="/dashboard"
          component={Dashboard}
          isAuthenticated={isAuthenticated}
        />
        <PrivateRoute
          path="/myjob"
          component={MyJobPage}
          isAuthenticated={isAuthenticated}
        />
        <PrivateRoute
          path="/myevent"
          component={MyEventPage}
          isAuthenticated={isAuthenticated}
        />
        <PrivateRoute
          path="/about"
          component={About}
          isAuthenticated={isAuthenticated}
        />
        <Route path="/error/401" component={Error401}></Route>
        <Route path="/error/403" component={Error403}></Route>
        <Route path="/login" component={Login}></Route>
        <PrivateRoute
          path="/projects"
          component={ProjectPage}
          isAuthenticated={isAuthenticated}
        />
        <PrivateRoute
          path="/members"
          component={MemberPage}
          isAuthenticated={isAuthenticated}
        />

        <Route
          exact
          path="/informfix"
          component={InformCard}
          isAuthenticated={isAuthenticated}
        />
        <Route
          exact
          path="/informfix/new"
          component={InformfixStatusOpenPage}
          isAuthenticated={isAuthenticated}
        />
        <Route
          exact
          path="/informfix/pending"
          component={InformfixPendingPage}
          isAuthenticated={isAuthenticated}
        />
        <Route
          exact
          path="/informfix/list"
          component={InformList}
          isAuthenticated={isAuthenticated}
        />
        <Route
          exact
          path="/informfix/view/:id"
          component={InformfixDetailPage}
          isAuthenticated={isAuthenticated}
        />

        <Route
          path="/informfix/waitconfirm"
          component={InformfixWaitConfirmPage}
          isAuthenticated={isAuthenticated}
        />
        <Route
          path="/informfix/task-again"
          component={InformfixTaskAginPage}
          isAuthenticated={isAuthenticated}
        />
        <Route
          path="/calendar"
          component={CalendarEventPage}
          isAuthenticated={isAuthenticated}
        />
        <Route
          path="/maintenance-fee"
          component={MaintenancePage}
          isAuthenticated={isAuthenticated}
        />

        <Route
          path="/technicians"
          component={technicianTable}
          isAuthenticated={isAuthenticated}
        />

        <Route
          path="/job-group"
          component={JobGroupPage}
          isAuthenticated={isAuthenticated}
        />
        <Route
          path="/jobs"
          component={JobPage}
          isAuthenticated={isAuthenticated}
        />
        <Route path="/weather-today" component={WeatherTodayPage} />
        <Route
          path="/complaint"
          component={ComplaintPage}
          isAuthenticated={isAuthenticated}
        />
        <Route
          path="/notifications"
          component={NotificationPage}
          isAuthenticated={isAuthenticated}
        />

        <Route exact component={NotFound} />
      </Switch>
    </div>
  )
}
export default Routers
